import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';

import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';

const SpinnerBuitSempreActiu = (props) => {
    return (
        <Spin spinning={true} delay={RETARD_MILISEGONS_APARICIO_SPINNER} >
            <div style={{height: props.height}}/>
        </Spin>
    );
};

SpinnerBuitSempreActiu.defaultProps = {
    height: '200px'
};

SpinnerBuitSempreActiu.propTypes = {
    height: PropTypes.string
};

export default SpinnerBuitSempreActiu;



// WEBPACK FOOTER //
// ./src/components/commons/spinnerBuitSempreActiu.js